import CardBase from 'components/cards/CardBase';
import React from 'react';

function FinalistPhotoCard({ media }) {
    return (
        <CardBase link={`/foto-izbor/finalisti/${media.id}`}>
            <div className="flex flex-col h-full">
                <img
                    src={media.files.conversions?.medium?.url}
                    alt="Foto izbor finalist"
                    className="w-full object-cover flex-1"
                />
                <div className="p-3 flex justify-between items-start">
                    <div>
                        <h4 className="text-brand font-serif">{media.user.name}</h4>
                        <strong className="text-sm">{media.poi.name}</strong>
                    </div>
                    <div className="rounded-full bg-gray-200 py-1 px-2 flex items-center justify-center gap-2">
                        <span>
                            <img src="/images/icons/heart.svg" width="18" height="18" alt="" />
                        </span>
                        <span className="font-medium">{media.votes}</span>
                    </div>
                </div>
            </div>
        </CardBase>
    );
}

export default FinalistPhotoCard;
